import ConfigurableFlexItem from './_configurable-flex-item.js'

export default {
  name: 'FlexPaneSeparator',
  values: {
    style: {
      size: undefined,
      color: undefined,
      margin: undefined,
      $mixin: [
        {
          configSet: ConfigurableFlexItem,
        },
      ],
    },
  },
  meta: {
    extendable: false,
  },
}
